import { LocaleUtilType } from "UidispatcherApiModule";
const { LocaleUtil }: { LocaleUtil: LocaleUtilType } =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    await import("uidispatcher_api/UidispatcherApiModule");
export default LocaleUtil;
